module.exports = __webpack_public_path__ + "media/images/amenities_icons/recording_studio-5aab4ab07a110fd7084f228d2c16bc2d.svg";